/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_TitleInputs */

const en_mk_sec_pg_title = /** @type {(inputs: Mk_Sec_Pg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is running today, and what is not`)
};

const id_mk_sec_pg_title = /** @type {(inputs: Mk_Sec_Pg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang sudah berjalan, dan apa yang belum`)
};

/**
* | output |
* | --- |
* | "What is running today, and what is not" |
*
* @param {Mk_Sec_Pg_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_title = /** @type {((inputs?: Mk_Sec_Pg_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_title(inputs)
	return en_mk_sec_pg_title(inputs)
});